<template>
    <div>
        <div class="com-page-title">
            <div class="inner">{{ $route.meta.title }}</div>
        </div>
        
        <van-list
            v-model:loading="loading"
            :finished="finished"
            @load="getList"
        >
            <div class="com-card" v-for="lst in list" :key="lst.id">
                <div class="com-card-title">{{ lst.name }}</div>
                <div class="com-card-content">
                    <div class="text-wrap">
                        <div class=" com-text-justify" v-html="lst.brief?.replace(/\n/gi, '<br>')" />
                        <p class="t1" v-if="!childList[lst.id]">参与请联系净慈寺客堂（联系方式见页尾）。</p>
                    </div>
                    <ul class="com-list-grid" v-if="childList[lst.id]">
                        <li v-for="child in childList[lst.id]" :key="child.id" @click="toNext({ id: child.id, title: lst.name })">
                        <!-- <li v-for="child in childList[lst.id]" :key="child.id" @click="$router.push({ path: 'foshi/detail', query: { id: child.id, title: lst.name } })"> -->
                            <img :src="$joinImgPrefix(child.picUrl)" alt="" />
                            <div class="text">
                                <p class="t1">{{ child.name }}</p>
                                <div class="line van-hairline--bottom" />
                                <p class="t2">{{ child.price != 0 ? `¥${child.price}` : '联系客堂' }}</p>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </van-list>
    </div>
</template>

<script>
    import { getUserInfo } from '@/utils/auth'
    import realRegisterTip from '@/utils/RealRegisterTip'
    export default {
        data () {
            return {
                userInfo: getUserInfo(),
                loading: false,
                finished: false,
                list: [],
                childList: {},
                page: 1,
                limit: 10
            }
        },
        methods: {
            // 详情页
            toNext (query) {
                // 已实名用户才能进入下一页
                if (this.userInfo.status == 1) {
                  this.$router.push({
                      path: 'foshi/detail',
                      query
                  })
                } else {
                    realRegisterTip()
                }
            },
            // 查询分类列表
            getList () {
                this.$faWuApi.foShi.list({
                    page: this.page,
                    limit: this.limit
                }).then(res => {
                    if (res.success) {
                        const data = res.data
                        // 查询子列表
                        this.getChildList(data.list)
                        if (data.list.length < this.limit) {
                            this.finished = true
                        }

                        this.page ++
                        this.list = this.list.concat(data.list)
                        this.loading = false
                    } else {
                        this.$toast(res.errMessage)
                    }
                })
            },
            // 查询分类下面的内容列表
            getChildList (pList) {
                pList.forEach(p => {
                    p.children = []
                    this.$faWuApi.foShi.getChildList({
                        pId: p.id,
                        page: 1,
                        limit: 99
                    }).then(res => {
                        if (res.success) {
                            if (res.data.list.length) {
                                this.childList[p.id] = res.data.list
                            }
                        } else {
                            this.$toast(res.errMessage)
                        }
                    })
                })
            }
        },
        components: {
        }
    }
</script>